// index.ts
import { CRUDL, installExtension } from "@juitnow/lib-fetch-client";
export * from "../types/validators.mjs";
var DeliverySlotsImpl = class {
  _crudl;
  constructor(http) {
    this._crudl = new CRUDL(http, "/deliveries/v1/slots");
  }
  read(id) {
    return this._crudl.read(id);
  }
  list(query) {
    return this._crudl.list({ ...query });
  }
  /* Slots Management */
  update(id, patch) {
    return this._crudl.update(id, patch);
  }
  async read_template() {
    const response = await this._crudl.http.get("/deliveries/v1/slots-config/template");
    return response.data;
  }
  async update_template(patch) {
    const response = await this._crudl.http.put("/deliveries/v1/slots-config/template", patch);
    return response.data;
  }
};
var SlotsClosuresImpl = class {
  _closuresCrudl;
  _statesCrudl;
  constructor(http) {
    this._closuresCrudl = new CRUDL(http, "/deliveries/v1/slots-config/closures");
    this._statesCrudl = new CRUDL(http, "/deliveries/v1/slots-config/states");
  }
  create(closure) {
    return this._closuresCrudl.create(closure);
  }
  read(date) {
    return this._closuresCrudl.read(date);
  }
  list(query) {
    return this._closuresCrudl.list({ ...query });
  }
  delete(date) {
    return this._closuresCrudl.delete(date);
  }
  async list_states(query) {
    return this._statesCrudl.list(query);
  }
};
installExtension("deliverySlots", DeliverySlotsImpl);
installExtension("slotsClosures", SlotsClosuresImpl);
export {
  DeliverySlotsImpl,
  SlotsClosuresImpl
};
//# sourceMappingURL=index.mjs.map
